import { useCallback, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { Flex } from "@chakra-ui/react";

import { logout } from "@/api/usersApi";
import { Navbar } from "@/components/Navbar";
import { useSessionExpiration } from "@/hooks/useSessionExpiration";

const Layout = () => {
    const navigate = useNavigate();

    const auth = useAuth();

    const handleSignin = useCallback(() => {
        auth.clearStaleState();
        auth.signinRedirect({ state: globalThis.location.href });
    }, [auth]);

    const handleSignout = useCallback(async () => {
        sessionStorage.removeItem("selectedBranch");
        sessionStorage.removeItem("actOnBehalfOf");
        sessionStorage.removeItem("wasAuthenticated");

        try {
            await logout();
        } catch (error) {
            //eslint-disable-next-line no-console
            console.error("Error logging out:", error);
        }

        // eslint-disable-next-line camelcase
        auth.signoutRedirect({ redirectMethod: "replace", post_logout_redirect_uri: import.meta.env.BASE_URL + "/" });
    }, [auth]);

    const handleNavigate = useCallback(() => {
        navigate("/");
    }, [navigate]);

    useEffect(() => {
        if (auth.error) {
            auth.removeUser();
        }
    }, [auth]);

    useSessionExpiration();

    return (
        <Flex as="nav" w="100%" wrap="wrap" backgroundColor="white" justifyContent="center">
            <Navbar
                isAuthenticated={auth.isAuthenticated}
                profileName={auth.user?.profile.name}
                profileEmail={auth.user?.profile.email}
                onSignout={handleSignout}
                onSignin={handleSignin}
                onNavigate={handleNavigate}
                isAuthLoading={auth.isLoading}
            />
        </Flex>
    );
};

export default Layout;
